import { Layout, Typography, Row, Col, Card, Button,Space } from 'antd';
import { useState, useEffect } from 'react';
import {
  BookOutlined,
  CustomerServiceOutlined,
  ArrowRightOutlined,
  MessageOutlined,
  ClockCircleOutlined,
  SafetyCertificateOutlined,
  FileTextOutlined,
  LockOutlined,
} from '@ant-design/icons';
import Sidebar from '../components/Sidebar';
import AppHeader from '../components/Header';

import image_illu from '../assets/help-desk.png';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;


export default function Support() {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://salesiq.zohopublic.in/widget?wc=siq84646a54c0ed16a2fa31eb4a0c59a20fbefd8488b0d78e393036f03e317fc106";
    script.defer = true;
    script.id = "zsiqscript";
    
    script.onload = () => {
      window.$zoho = window.$zoho || {};
      window.$zoho.salesiq = window.$zoho.salesiq || { ready: (callback) => callback() };

      window.$zoho.salesiq.ready(() => {
        console.log("Zoho SalesIQ chat is ready");
      });
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const openZohoChat = () => {
  if (
    window.$zoho &&
    window.$zoho.salesiq &&
    window.$zoho.salesiq.floatwindow
  ) {
    window.$zoho.salesiq.floatwindow.visible('show');
  } else {
    console.warn('Zoho SalesIQ not loaded yet');
  }
};

  return (
    <Layout style={{ minHeight: '125vh', flexDirection: 'row' }}>
      <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
      <Layout className="site-layout" >
        <AppHeader />
        <Content style={{ margin: '0 16px', overflow: 'scroll', height: 'calc(100vh - 64px)' }}>

          <div
      style={{
        background: 'linear-gradient(135deg, #f8f6ff 0%, #fff7fb 100%)',
        border: '1px solid #f0e9ff',
        borderRadius: 28,
        padding: 40,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {/* Top Header */}
      <Row
        gutter={[40, 40]}
        align="middle"
        justify="space-between"
      >
        <Col xs={24} md={14}>
          <div>
            <Title
              level={1}
              style={{
                margin: 0,
                fontWeight: 800,
                color: '#101828',
                fontSize: 48,
                lineHeight: 1.1,
                letterSpacing: '-1px',
              }}
            >
              Help & Support
            </Title>

            <Paragraph
              style={{
                marginTop: 18,
                fontSize: 18,
                color: '#667085',
                maxWidth: 600,
                lineHeight: 1.7,
              }}
            >
              We’re here to help! Explore our resources or get in touch
              with our support team anytime you need assistance.
            </Paragraph>
          </div>
        </Col>

        <Col
          xs={24}
          md={10}
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              position: 'relative',
            }}
          >
            <div
              style={{
                width: 320,
                height: 320,
                borderRadius: '50%',
                background:
                  'radial-gradient(circle, rgba(124,58,237,0.12) 0%, rgba(124,58,237,0.03) 70%)',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            />

            <img
              src={image_illu}
              alt="support"
              style={{
                height: 280,
                objectFit: 'contain',
                position: 'relative',
                zIndex: 2,
              }}
            />
          </div>
        </Col>
      </Row>

      {/* Cards */}
      <Row
        gutter={[24, 24]}
        style={{
          marginTop: 20,
        }}
      >
        {/* Help Articles */}
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              borderRadius: 24,
              height: '100%',
              overflow: 'hidden',
              boxShadow: '0 8px 30px rgba(124,58,237,0.06)',
            }}
            bodyStyle={{
              padding: 32,
            }}
          >
            <Row gutter={20} align="middle">
              <Col flex="1">
                <div
                  style={{
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    background: '#f3e8ff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: 24,
                  }}
                >
                  <BookOutlined
                    style={{
                      fontSize: 30,
                      color: '#7c3aed',
                    }}
                  />
                </div>

                <Title
                  level={2}
                  style={{
                    margin: 0,
                    fontWeight: 700,
                    color: '#101828',
                  }}
                >
                  Help Articles
                </Title>

                <Paragraph
                  style={{
                    marginTop: 16,
                    color: '#667085',
                    fontSize: 16,
                    lineHeight: 1.8,
                  }}
                >
                  Find step-by-step guides, tutorials and answers to
                  common questions.
                </Paragraph>

                <Button
                  type="primary"
                  size="large"
                  icon={<ArrowRightOutlined />}
                  iconPosition="end"
                  onClick={() =>
                    window.open(
                      'https://exellius.zohodesk.in/portal/en/home',
                      '_blank'
                    )
                  }
                  style={{
                    marginTop: 12,
                    height: 52,
                    paddingInline: 28,
                    borderRadius: 14,
                    background:
                      'linear-gradient(90deg, #7c3aed 0%, #8b5cf6 100%)',
                    border: 'none',
                    fontWeight: 600,
                    boxShadow:
                      '0 8px 20px rgba(124,58,237,0.25)',
                  }}
                >
                  Browse Help Articles
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* Contact Support */}
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              borderRadius: 24,
              height: '100%',
              overflow: 'hidden',
              boxShadow: '0 8px 30px rgba(16,24,40,0.06)',
            }}
            bodyStyle={{
              padding: 32,
            }}
          >
            <div
              style={{
                width: 72,
                height: 72,
                borderRadius: '50%',
                background: '#e7faf4',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 24,
              }}
            >
              <CustomerServiceOutlined
                style={{
                  fontSize: 30,
                  color: '#10b981',
                }}
              />
            </div>

            <Title
              level={2}
              style={{
                margin: 0,
                fontWeight: 700,
                color: '#101828',
              }}
            >
              Contact Support
            </Title>

            <Paragraph
              style={{
                marginTop: 16,
                color: '#667085',
                fontSize: 16,
                lineHeight: 1.8,
              }}
            >
              Our support team is available 24/7 to help you with any
              questions or issues.
            </Paragraph>

            <Space
              size={16}
              wrap
              style={{
                marginTop: 20,
              }}
            >
              <Button
                size="large"
                href="mailto:support@exellius.com"
                style={{
                  height: 52,
                  paddingInline: 30,
                  borderRadius: 14,
                  border: '1px solid #10b981',
                  color: '#10b981',
                  fontWeight: 600,
                }}
                icon={<ArrowRightOutlined />}
                iconPosition="end"
              >
                Contact Us
              </Button>

              <Button
                type="primary"
                size="large"
                onClick={openZohoChat}
                icon={<MessageOutlined />}
                style={{
                  height: 52,
                  paddingInline: 30,
                  borderRadius: 14,
                  background:
                    'linear-gradient(90deg, #10b981 0%, #34d399 100%)',
                  border: 'none',
                  fontWeight: 600,
                  boxShadow:
                    '0 8px 20px rgba(16,185,129,0.25)',
                }}
              >
                Live Chat
              </Button>
            </Space>
          </Card>
        </Col>
      </Row>

      {/* Bottom Features */}
      <Card
        bordered={false}
        style={{
          marginTop: 28,
          borderRadius: 24,
          boxShadow: '0 8px 30px rgba(16,24,40,0.04)',
        }}
        bodyStyle={{
          padding: 28,
        }}
      >
        <Row gutter={[24, 24]}>
          {[
            {
              icon: <ClockCircleOutlined />,
              title: '24/7 Support',
              desc: 'We’re always here when you need us',
              bg: '#eef4ff',
              color: '#3b82f6',
            },
            {
              icon: <SafetyCertificateOutlined />,
              title: 'Quick Response',
              desc: 'Average response time under 2 hours',
              bg: '#f4ebff',
              color: '#8b5cf6',
            },
            {
              icon: <FileTextOutlined />,
              title: 'Helpful Resources',
              desc: 'Guides and articles to solve issues fast',
              bg: '#fff7e8',
              color: '#f59e0b',
            },
            {
              icon: <LockOutlined />,
              title: 'Secure & Private',
              desc: 'Your data and privacy are our priority',
              bg: '#fdf2f8',
              color: '#ec4899',
            },
          ].map((item, index) => (
            <Col xs={24} sm={12} lg={6} key={index}>
              <div
                style={{
                  display: 'flex',
                  gap: 16,
                  alignItems: 'flex-start',
                }}
              >
                <div
                  style={{
                    width: 62,
                    height: 62,
                    borderRadius: '50%',
                    background: item.bg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <div
                    style={{
                      fontSize: 26,
                      color: item.color,
                    }}
                  >
                    {item.icon}
                  </div>
                </div>

                <div>
                  <Text
                    strong
                    style={{
                      fontSize: 18,
                      color: '#101828',
                      display: 'block',
                      marginBottom: 8,
                    }}
                  >
                    {item.title}
                  </Text>

                  <Text
                    style={{
                      color: '#667085',
                      fontSize: 15,
                      lineHeight: 1.7,
                    }}
                  >
                    {item.desc}
                  </Text>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
          
          
        </Content>
      </Layout>
    </Layout>
  );
}
